require('jquery');
import Archive from '../class/Archive';
import { post } from '../utils/functions';
import SearchDropdown from 'src/class/SearchDropdown';

class Blog {
	constructor(className) {
		this.sections = document.querySelectorAll(`.${className}`);
		this.sections.forEach((section) => {
			new Section(section);
		});
	}
}

class Section {
	constructor(section) {
		this.archive = new Archive(section, { prefetch: false });

		// const searchForm = document.querySelector('.search__form');
		// searchForm.addEventListener('submit', (e) => e.stopPropagation());
		// const searchInput = searchForm.querySelector('input');
		// new SearchDropdown(searchInput, {
		// 	anchorElement: searchForm,
		// });
	}
}

export default Blog;
